"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
const useStyles = (0, _styles.makeStyles)({
  root: {
    display: 'block',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    },
    '& .guestButtonWrapper': {
      display: 'flex',
      alignItems: 'center',
      padding: '16px 10px 16px'
    }
  }
});
var _default = exports.default = useStyles;